import { render, staticRenderFns } from "./ProjectSelector.vue?vue&type=template&id=6920143e&"
import script from "./ProjectSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports